export default __webpack_public_path__ + "44a77879c95d15ba43df704d582268ae.svg";